export enum FLOW_EMAILATTACHMENT_TYPE {
  FLOW_EMAILATTACHMENT = 'Flow_EmailAttachment',
}
